/** OIDC scopes requested for Auth0 Universal Login + API access tokens. */
export const AUTH0_SCOPE = 'openid profile email offline_access'

/**
 * OAuth redirect URI registered in Auth0 (must match Allowed Callback URLs exactly).
 */
export function getAuth0RedirectUri(): string {
  const fromEnv = import.meta.env.VITE_AUTH0_REDIRECT_URI?.trim()
  if (fromEnv) {
    return fromEnv
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/auth/redirect`
  }
  return 'http://localhost:5173/auth/redirect'
}
